import { FC } from 'react';
import styles from './LitresRating.module.scss';

interface ILitresRating {
  litresRating?: number;
  liveLibRating?: number;
}

const LitresRating: FC<ILitresRating> = ({ litresRating, liveLibRating }) => {
  const LIVE_LIB_NAME = 'Livelib';
  const LITRES_NAME = 'Литрес';
  const ratingData = [];

  if (litresRating !== 0) {
    ratingData.push({ name: LITRES_NAME, rating: litresRating });
  }
  if (liveLibRating !== 0) {
    ratingData.push({ name: LIVE_LIB_NAME, rating: liveLibRating });
  }

  return (
    <ul className={styles.litresRating}>
      {ratingData.length > 0 &&
        ratingData.map((item) => (
          <li className={item.name === LIVE_LIB_NAME ? `${styles.litresRating__item} ${styles.litresRating__item_liveLib}` : `${styles.litresRating__item}`}>
            <span className={styles.litresRating__site}> {item.name}:</span>
            <span className={styles.litresRating__number}>{item.rating}</span>
          </li>
        ))}
    </ul>
  );
};
export default LitresRating;
